export class StoreLocationOverride {
  id: number;
  sourceStoreLocationId: number;
  destinationStoreLocationId: number;
  brandId: number;
  sourceName: string;
  destinationName: string;
  startDate: string;
  endDate: string;
}
